
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TutorialMaterial } from '../../models/tutorial.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TutorialMaterialService } from '../../services/tutorial-class.service';


@Component({
  selector: 'app-tutorial-material-edit',
  templateUrl: './tutorial-material-edit.component.html',
  styleUrls: ['./tutorial-material-edit.component.scss', './../../tutorial.scss']
})
export class TutorialMaterialEditComponent extends BaseFormComponent<TutorialMaterial> implements OnInit {
  actionLabel: string = 'Novo';
  data: TutorialMaterial;
  selectedFile: File | null = null;
  @Input() id:number;
  @Input() tutorialId:number;
  @Output() closeModal = new EventEmitter<void>();

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: TutorialMaterialService
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.initForm();
    this.start();
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      duration: new FormControl(''),
      file_link: new FormControl(null),
      tutorial_id: new FormControl(this.tutorialId),
      file_name:new FormControl(null)
    });
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  start(): void{
    if(this.id){
      this.myService.getById(this.id).subscribe(
        (res) => {
          this.entity = res;
          this.data = res;
          this.initForm();
          this.loaded();
        },
        (error) => {
          this.msgError(error?.error?.message);
          this.loaded();
        },
      )
    }
    else{
      this.loaded();
    }
  }

  getDataCreate(): object {
    return Object.assign({}, this.form.value);
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.uploadFile( this.entity?.id, this.getDataCreate(),this.selectedFile).subscribe({
          next: (res) => {
            this.confirmation("Tutorial salvo com sucesso!").subscribe(() => {
              window.location.reload();
            })
            this.loaded();
          },
          error: (error) => {
            let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
            this.msgError(msg);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

  onCloseModal(): void{
    this.closeModal.emit();
  }

}
